<template>
    <div>
        <v-card>
            <v-card-title>
                {{ webhookType }} Webhooks
                <v-btn
                    class="ml-auto"
                    icon
                    color="secondary"
                    @click="tips = !tips">
                    <v-icon dark>
                        mdi-information
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="p-0">
                <v-alert
                    :value="tips"
                    outlined
                    color="primary"
                    dark
                    border="right"
                    transition="scale-transition"
                    class="mx-5">
                    <div class="title">
                        Tips
                    </div>
                    <p v-for="(tip, index) in webhookTips"
                        :key="'tips-' + index">
                        {{ tip }}
                    </p>
                </v-alert>

                <div v-if="integrationId" class="mx-5">
                    <v-progress-linear
                        v-if="isLoading"
                        indeterminate
                        color="primary"
                        class="mb-5">
                    </v-progress-linear>
                    <v-form
                        ref="form">
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    Subscribe to Order/Create
                                </v-list-item-content>
                                <v-list-item-action>
                                    <div>
                                        <v-switch :input-value="hasOrdersCreate" @change="triggerTopic('orders/create')" color="primary" class="mb-0"></v-switch>
                                    </div>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    Subscribe to Order/Updated
                                </v-list-item-content>
                                <v-list-item-action>
                                    <div>
                                        <v-switch :input-value="hasOrdersUpdated" @change="triggerTopic('orders/updated')" color="primary" class="mb-0"></v-switch>
                                    </div>
                                </v-list-item-action>
                            </v-list-item>

                            <div v-if="type == 'Shopify'">
                                <v-list-item v-for="shopifyHook in shopifyWebhooks" :key="'webhook-' + shopifyHook.text">
                                    <v-list-item-content>
                                        Subscribe to {{ shopifyHook.text }}
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <div>
                                            <v-switch v-if="hasWebhook(shopifyHook.text)" value=true @change="triggerTopic(shopifyHook.text)" color="primary" class="mb-0"></v-switch>
                                            <v-switch v-else value=false @change="triggerTopic(shopifyHook.text)" color="primary" class="mb-0"></v-switch>
                                        </div>
                                    </v-list-item-action>

                                </v-list-item>
                            </div>

                        </v-list>
                    </v-form>

                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'

export default {
    props: {
        id: { type: Number, default: null },
        type: { type: String, default: "" },
    },

    computed: {
        webhookType() {
            return this.type
        },

        integrationId() {
            return this.id
        },

        hasOrdersCreate() {
            return this.webhooks.some(function(field) {
                return field.topic === 'orders/create'
            });
        },

        hasOrdersUpdated() {
            return this.webhooks.some(function(field) {
                return field.topic === 'orders/updated'
            });
        }
    },


    data() {
        return {
            isCreate: false,
            isUpdated: false,
            isLoading: false,
            webhooks: [],
            tips: false,
            webhookTips: [
                'order/create - Received every creation of ' + this.type + ' order',
                'order/updated - Received every update  of ' + this.type + ' order'
            ],
            shopifyWebhooks: [
                { text: 'orders/cancelled', value: 'Occurs whenever an order is cancelled.'},
                { text: 'orders/delete', value: 'Occurs whenever an order is deleted.'},
                { text: 'fulfillment_orders/moved', value: this.type + ' order whose location has been changed.'},
                { text: 'fulfillment_orders/split', value: 'Fulfillment order has had items split into a new FO.'},
                { text: 'fulfillment_orders/order_routing_complete', value: 'Occurs when an order has finished being routed and assigned to a fulfillment location.'},
                { text: 'fulfillment_orders/placed_on_hold', value: 'Occurs when a fulfillment order is placed on hold.'},
                { text: 'fulfillment_orders/hold_released', value: 'Occurs when a fulfillment order hold is released.'},
                { text: 'fulfillments/update', value: 'Occurs whenever a fulfillment is updated.'},
            ]
        }
    },

    mounted() {

        this.fetchWebhooks();
    },

    methods: {

        hasWebhook(text) {
            return this.webhooks.some(function(field) {
                return field.topic === text
            });
        },

        fetchWebhooks() {
            if (this.type.toLowerCase() == 'shopify') {
                this.webhookTips = [];
                this.webhookTips.push(
                    'order/create - Received every creation of Shopify order',
                    'order/updated - Received every update of Shopify order',
                    'fulfillment_orders/moved - ' + this.type + ' order whose location has been changed.',
                    'fulfillment_orders/split - Fulfillment order has had items split into a new FO.',
                    'fulfillment_orders/order_routing_complete - occurs when an order has finished being routed and assigned to a fulfillment location.',
                    'fulfillment_orders/placed_on_hold - Occurs when a fulfillment order is placed on hold.',
                    'fulfillment_orders/hold_released - Occurs when a fulfillment order hold is released.',
                    'fulfillments/update - Occurs whenever a fulfillment is updated.',
                );
            }
            this.$http
            .get('/api/webhooks/'+this.type.toLowerCase()+'/' + this.id)
            .then(({ data  }) => {
                if (data.code == 200) {
                    this.webhooks = data.result.webhooks.map(webhook => {
                        return {'topic':webhook.topic,'id':webhook.id}
                    })
                }
            })
        },

        async triggerTopic(topic) {

            let getId = null;
            this.webhooks.map(webhook => {
                if (webhook.topic == topic) {
                    getId = webhook.id
                }
            })
            console.log(getId);

            // stops spam
            if (this.isLoading) {
                return;
            }
            try {
                this.isLoading = true

                if (getId) {
                    this.$http.get('/api/webhooks/'+this.type.toLowerCase()+'/delete/' + this.id + '/' + getId)
                    .then((data) => {
                        console.log(data)
                        if (data.data.code == 200) {

                            EventBus.$emit('show-success', 'Successfully Unsubscribe to ' + topic + '.');
                        }
                        else if (data.data.errors) {

                            EventBus.$emit('show-error', JSON.stringify(data.data.errors))
                        }
                        this.isLoading = false
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                        this.isLoading = false
                    })
                }
                else {
                    let subsData = {
                        'topic':  topic
                    };
                    this.$http.post('/api/webhooks/'+this.type.toLowerCase()+'/subscribe/' + this.id, subsData)
                    .then((data) => {
                        console.log(data)
                        if (data.data.code == 200 || data.data.code == 201) {

                            this.fetchWebhooks()
                            EventBus.$emit('show-success', 'Successfully Subscribe to ' + topic + '.');
                        }
                        else if (data.data.errors) {
                            EventBus.$emit('show-error', JSON.stringify(data.data.errors))
                        }
                        this.isLoading = false
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                        this.isLoading = false
                    })
                }


            } catch (err) {
                EventBus.$emit('show-err', err);

                this.isLoading = false
            }
        }
    }
}
</script>
